import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    lexicalSectionTitle: string;
    nlpSectionTitle: string;
    nlpSectionTooltip: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Section title for standard/lexical search results */
            lexicalSectionTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useQuickSearchMachineMulti.lexicalSectionTitle?c=33g0wpc6wzfan", defaultMessage: "Standard Results" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Section title for AI/NLP search results */
            nlpSectionTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useQuickSearchMachineMulti.nlpSectionTitle?c=lmyia2b8ckk1", defaultMessage: "AI Results" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text explaining AI search capabilities */
            nlpSectionTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "useQuickSearchMachineMulti.nlpSectionTooltip?c=1bkoris4jpuse", defaultMessage: "AI search surfaces results that go beyond keywords." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
